const PATH = 'fe.components.reliability_test.enter_codes_section';

const messages = {
  enterCodes: {
    key: `${PATH}.enter_codes`,
    defaultValue: 'Enter Codes'
  },
  status: {
    completed: {
      key: `${PATH}.status_completed`,
      defaultValue: 'All dimensions have been scored'
    },
    pending: {
      key: `${PATH}.status_pending`,
      defaultValue: 'Not all dimensions have been scored'
    },
    error: {
      key: `${PATH}.status_error`,
      defaultValue: 'Some dimensions are missing codes'
    }
  }
};

export default messages;
